/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
          $(window).scroll(function(e){ 
              var $el = $('.banner'); 
              var isPositionFixed = ($el.css('position') == 'fixed');
              if ($(this).scrollTop() > 40 && !isPositionFixed){ 
                $('.banner').css({'position': 'fixed', 'top': '0px'}); 
                $('.banner').next().css('margin-top', '124px');
              }
              if ($(this).scrollTop() < 40 && isPositionFixed)
              {
                $('.banner').css({'position': 'static', 'top': '0px'});
                $('.banner').next().css('margin-top', '0');
              } 
            }); 
          
          
          var href = location.href;
          var lasthref = href.match(/([^\/]*)\/*$/)[1];
          if(lasthref === '#goederenheffer'){
              jQuery('html, body').animate({scrollTop: jQuery(".goederenheffer-section").offset().top - 124}, 'slow');
          }else if(lasthref === '#goederenheffermpv'){
              jQuery('html, body').animate({scrollTop: jQuery(".goederenheffermpv-section").offset().top - 124}, 'slow');
          }
          else if(lasthref === '#kleingoederenheffer'){
             jQuery('html, body').animate({scrollTop: jQuery(".kleingoederenheffer-section").offset().top - 124}, 'slow');
          }
          else if(lasthref === '#wiezijnwij'){
             jQuery('html, body').animate({scrollTop: jQuery(".wie-zijn-wij-section").offset().top - 124}, 'slow');
          }
          else if(lasthref === '#klantervaringen'){
              jQuery('html, body').animate({scrollTop: jQuery(".klantervaringen-section").offset().top - 124}, 'slow');
          }
          else if(lasthref === '#werkwijze'){
              jQuery('html, body').animate({scrollTop: jQuery(".werkwijze-section").offset().top - 124}, 'slow');
          }
          else if(lasthref === '#onzeklanten'){
              jQuery('html, body').animate({scrollTop: jQuery(".onze-klanten-section").offset().top - 124}, 'slow');
          }
          else if(lasthref === '#certificering'){
              jQuery('html, body').animate({scrollTop: jQuery(".certificering-section").offset().top - 124}, 'slow');
          }
          
          //zoom effect afbeelding bij hover
          $('.moduleItemContent').hover(function(){
              $(this).css('cursor','pointer').find('.moduleItemImage').find('img').css('transform','scale(1.1)');
          },function(){
              $(this).css('cursor','default').find('.moduleItemImage').find('img').css('transform','scale(1)');
          });
          
          //Plaats placeholders in het contactformulier
          var naam = document.getElementById('wpcf7-naam').htmlFor;
          $('input[name=your-name]').attr("placeholder", naam);
          
          var email = document.getElementById('wpcf7-email').htmlFor;
          $('input[name=your-email]').attr("placeholder", email);
          
          var bericht = document.getElementById('wpcf7-bericht').htmlFor;
          $('textarea[name=your-message]').attr("placeholder", bericht);
          
          var onderwerp = document.getElementById('wpcf7-onderwerp').htmlFor;
          $('input[name=your-subject]').attr("placeholder", onderwerp);
          
          
          
           
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
